module.exports = __webpack_public_path__ + "static/media/screenshot1.6359485f.png";